module.exports = "https://qp-assets.quero.com/assets/images/onboarding/secure.svg?3aa1a3689b5f2317bf7810d3060747da";